import { useState, useEffect } from 'react';

const API_URL = 'https://bot.devit.es/api';
const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('devit_token')}`
});

const DIAS = ['lunes','martes','miercoles','jueves','viernes','sabado','domingo'];
const DIAS_LABELS = {
  lunes:'Lunes', martes:'Martes', miercoles:'Miércoles',
  jueves:'Jueves', viernes:'Viernes', sabado:'Sábado', domingo:'Domingo'
};
const HORAS = Array.from({length:24}, (_,i) => `${String(i).padStart(2,'0')}:00`);

export default function Calendario() {
  const [disp, setDisp] = useState(null);
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    Promise.all([
      fetch(`${API_URL}/disponibilidad/`, { headers: headers() }).then(r => r.json()),
      fetch(`${API_URL}/disponibilidad/slots`, { headers: headers() }).then(r => r.json()),
    ]).then(([d, s]) => {
      setDisp(d);
      setSlots(s.slots || []);
      setLoading(false);
    });
  }, []);

  const updateDia = (dia, campo, valor) => {
    setDisp(prev => ({
      ...prev,
      horarios: {
        ...prev.horarios,
        [dia]: { ...prev.horarios[dia], [campo]: valor }
      }
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    const res = await fetch(`${API_URL}/disponibilidad/`, {
      method: 'PUT', headers: headers(),
      body: JSON.stringify({
        horarios: disp.horarios,
        duracion_cita: disp.duracion_cita,
        buffer_entre_citas: disp.buffer_entre_citas,
        calendario_tipo: disp.calendario_tipo
      })
    }).then(r => r.json());
    setMsg(res.status === 'ok' ? '✓ Guardado correctamente' : '✗ Error al guardar');
    setSaving(false);
    setTimeout(() => setMsg(''), 3000);
  };

  if (loading) return <div className="content" style={{color:'var(--text3)'}}>Cargando...</div>;

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Calendario</div>
          <div className="page-sub">Gestión de citas y disponibilidad</div>
        </div>
        <div className="topbar-actions">
          <div className="status-label">
            <span className="status-dot" style={{background: disp?.calendario_conectado ? 'var(--green)' : 'var(--red)'}}></span>
            {disp?.calendario_conectado ? 'Calendario conectado' : 'Sin calendario'}
          </div>
        </div>
      </div>

      <div className="content">
        {/* Configuración general */}
        <div className="card" style={{marginBottom:'16px'}}>
          <div className="card-title">Configuración de citas</div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Duración de cada cita</label>
              <select className="form-input" value={disp.duracion_cita}
                onChange={e => setDisp(p => ({...p, duracion_cita: parseInt(e.target.value)}))}>
                <option value={30}>30 minutos</option>
                <option value={45}>45 minutos</option>
                <option value={60}>1 hora</option>
                <option value={90}>1 hora 30 min</option>
                <option value={120}>2 horas</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Buffer entre citas</label>
              <select className="form-input" value={disp.buffer_entre_citas}
                onChange={e => setDisp(p => ({...p, buffer_entre_citas: parseInt(e.target.value)}))}>
                <option value={0}>Sin buffer</option>
                <option value={15}>15 minutos</option>
                <option value={30}>30 minutos</option>
                <option value={60}>1 hora</option>
              </select>
            </div>
          </div>
          <div className="form-group" style={{marginBottom:0}}>
            <label className="form-label">Tipo de calendario</label>
            <div style={{display:'flex', gap:'10px'}}>
              {['google', 'outlook'].map(tipo => (
                <div key={tipo} onClick={() => setDisp(p => ({...p, calendario_tipo: tipo}))}
                  style={{
                    padding:'10px 20px', borderRadius:'6px', cursor:'pointer',
                    border: disp.calendario_tipo === tipo ? '2px solid var(--green)' : '1px solid var(--border)',
                    background: disp.calendario_tipo === tipo ? 'rgba(0,229,160,0.05)' : 'var(--bg3)',
                    fontSize:'13px', color: disp.calendario_tipo === tipo ? 'var(--green)' : 'var(--text2)',
                    fontWeight: disp.calendario_tipo === tipo ? 600 : 400,
                  }}>
                  {tipo === 'google' ? '📅 Google Calendar' : '📧 Outlook / Hotmail'}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Horarios por día */}
        <div className="card" style={{marginBottom:'16px'}}>
          <div className="card-title">Horarios de disponibilidad</div>
          <div style={{display:'flex', flexDirection:'column', gap:'0'}}>
            {DIAS.map(dia => {
              const config = disp.horarios?.[dia] || {activo:false, inicio:'09:00', fin:'18:00'};
              return (
                <div key={dia} style={{
                  display:'grid', gridTemplateColumns:'140px 1fr',
                  alignItems:'center', padding:'12px 0',
                  borderBottom:'1px solid var(--border)'
                }}>
                  {/* Toggle + nombre día */}
                  <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                    <label className="toggle">
                      <input type="checkbox" checked={config.activo}
                        onChange={e => updateDia(dia, 'activo', e.target.checked)}/>
                      <span className="slider-toggle"></span>
                    </label>
                    <span style={{
                      fontSize:'13px', fontWeight:500,
                      color: config.activo ? 'var(--text)' : 'var(--text3)'
                    }}>
                      {DIAS_LABELS[dia]}
                    </span>
                  </div>

                  {/* Selectores de hora */}
                  {config.activo ? (
                    <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                      <select
                        className="form-input"
                        style={{width:'100px', padding:'6px 8px', fontSize:'12px'}}
                        value={config.inicio}
                        onChange={e => updateDia(dia, 'inicio', e.target.value)}
                      >
                        {HORAS.map(h => <option key={h} value={h}>{h}</option>)}
                      </select>
                      <span style={{color:'var(--text3)', fontSize:'12px'}}>hasta</span>
                      <select
                        className="form-input"
                        style={{width:'100px', padding:'6px 8px', fontSize:'12px'}}
                        value={config.fin}
                        onChange={e => updateDia(dia, 'fin', e.target.value)}
                      >
                        {HORAS.map(h => <option key={h} value={h}>{h}</option>)}
                      </select>
                      <span style={{fontSize:'11px', color:'var(--text3)'}}>
                        {(() => {
                          const [hi,mi] = config.inicio.split(':').map(Number);
                          const [hf,mf] = config.fin.split(':').map(Number);
                          const mins = (hf*60+mf) - (hi*60+mi);
                          if (mins <= 0) return '';
                          const h = Math.floor(mins/60);
                          const m = mins%60;
                          return h > 0 ? `${h}h${m>0?` ${m}min`:''}` : `${m}min`;
                        })()}
                      </span>
                    </div>
                  ) : (
                    <span style={{fontSize:'12px', color:'var(--text3)'}}>No disponible</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Próximos slots disponibles */}
        <div className="card" style={{marginBottom:'16px'}}>
          <div className="section-header">
            <div className="section-title">Próximos slots disponibles</div>
            <button className="btn btn-ghost" style={{fontSize:'11px', padding:'5px 12px'}}
              onClick={() => {
                fetch(`${API_URL}/disponibilidad/slots`, { headers: headers() })
                  .then(r => r.json()).then(s => setSlots(s.slots || []));
              }}>
              ↺ Actualizar
            </button>
          </div>
          {slots.length === 0 ? (
            <div style={{fontSize:'12px', color:'var(--text3)', marginTop:'8px'}}>
              {disp?.calendario_conectado
                ? 'No hay slots disponibles en los próximos 7 días.'
                : 'Conecta tu Google Calendar para ver disponibilidad real.'}
            </div>
          ) : (
            <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(140px, 1fr))', gap:'8px', marginTop:'12px'}}>
              {slots.slice(0, 12).map((slot, i) => (
                <div key={i} style={{
                  background:'var(--bg3)', border:'1px solid var(--border)',
                  borderRadius:'6px', padding:'8px 10px', fontSize:'11px'
                }}>
                  <div style={{color:'var(--green)', fontWeight:600}}>{slot.hora}</div>
                  <div style={{color:'var(--text2)', marginTop:'2px', fontSize:'10px'}}>
                    {slot.fecha}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {msg && (
          <div className={`alert ${msg.startsWith('✓') ? 'alert-success' : 'alert-warn'}`}
            style={{marginBottom:'12px'}}>
            {msg}
          </div>
        )}

        <div style={{display:'flex', gap:'10px'}}>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Guardando...' : '✓ Guardar disponibilidad'}
          </button>
          <button className="btn btn-ghost" onClick={() => window.location.reload()}>
            Descartar
          </button>
        </div>
      </div>
    </div>
  );
}
